import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import moment from 'moment';
import readXlsxFile from 'read-excel-file';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { PurchaseOrderEnums } from 'src/app/enum/purchase-order-enum';
import { UserModel } from 'src/app/models/authentication/user.model';
import { PurchaseOrderImportModel } from 'src/app/models/imports/purchase-order-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { PurchaseOrderService } from 'src/app/services/shopping/purchase-order.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-purchase-order-import',
  templateUrl: './purchase-order-import.component.html',
  styleUrls: ['./purchase-order-import.component.scss'],
  standalone: false
})
export class PurchaseOrderImportComponent implements OnInit, OnDestroy {

  companyCode: number | null = null;
  companyId: number = 0;
  eventFile: any;
  errorPurchaseOrder: number = 0;
  filters: ColumnResponseModel[] = [];
  formImport: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  listCompanies: any[] = [];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  purchaseOrderAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  nameFile: string = 'Ningún archivo seleccionado.';
  nameWindow: string = 'Importación Órdenes de Compra';
  permissionUpdatable: boolean = false;
  url: string = "purchase-order-import";
  userAuthenticated: UserModel = new UserModel();
  visibleTxt: boolean = false;
  projectName = ProjectName.projectName;

  private readonly formBuilder = inject(FormBuilder);
  private readonly companyService = inject(CompanyService);
  private readonly headerService = inject(HeaderService)
  private readonly purchaseOrderService = inject(PurchaseOrderService);
  private readonly router = inject(Router);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly title = inject(Title);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);

  ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.headerService.setTitle(this.nameWindow);
    this.getPermission();
    this.validateForm();
    this.getAllLists();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      let windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window !== -1) {
        windowsOpened = windowsOpened.filter(x => x !== this.url);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  downloadErrorsTxt() {
    if (!this.purchaseOrderAlerts || this.purchaseOrderAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.purchaseOrderService.exportImportErrors(this.purchaseOrderAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionOrdenesDeCompra_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.purchaseOrderService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaOrdenesDeCompra.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  importPurchaseOrder() {
    this.purchaseOrderAlerts = [];
    this.errorPurchaseOrder = 0;
    this.visibleTxt = false;
    Object.keys(this.formImport.controls).forEach(key => {
      const control = this.formImport.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formImport.valid) {
      let isOk: boolean = true;
      const input = document.getElementById("fileImport") as any;
      const rowsImports = new Array<PurchaseOrderImportModel>();
      let row: PurchaseOrderImportModel;
      let counter: number = 1, branchCode: number = 0, consecutive: number = 0, alterNumber: number | null = null, purchaseOrderDate: Date = new Date(), enterpriseCode: number = 0,
        providerDocument: string = "", address: string = "", wayToPayCode: number = 0, referenceDocument: string = "", purchaseOrderState: number = 0,
        observation: string | null = null, subtotalValue: number = 0, ivaValue: number = 0, articleCode: number = 0, quantity: number = 0, ajustedQuantity: number = 0,
        unitValue: number = 0, ajustedUnitValue: number = 0, discountRate: number = 0, ajustedDiscountRate: number = 0, ivaRate: number = 0, ajustedIvaRate: number = 0,
        internalOrderConsecutive: number | null = null;
      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast('warning', `El archivo ingresado no tiene registros para importar`);
            return;
          }
          rows.splice(0, 1);
          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;
            //A. Código Compañía:
            const companyCode = parseFloat(element[0] as string);
            if (isNaN(companyCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El campo código compañía es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }
            if (companyCode != this.companyCode) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. La compañía del archivo no es igual a la compañía seleccionada.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //B. Código Sucursal:
            branchCode = parseFloat(element[1] as string);
            if (isNaN(branchCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El campo código sucursal es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //C. Consecutivo
            consecutive = parseFloat(element[2] as string);
            if (isNaN(consecutive)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna C. El campo consecutivo es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //D. Número Alterno
            alterNumber = parseFloat(element[3] as string);

            //E. Código Empresa
            enterpriseCode = parseFloat(element[4] as string);
            if (isNaN(enterpriseCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna E. El campo código empresa es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //F. Estado
            purchaseOrderState = parseFloat(element[5] as string);
            if (isNaN(purchaseOrderState)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna F. El campo estado es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }
            if (purchaseOrderState != PurchaseOrderEnums.stateOpen && purchaseOrderState != PurchaseOrderEnums.stateInitialClose &&
              purchaseOrderState != PurchaseOrderEnums.stateFinalClose && purchaseOrderState != PurchaseOrderEnums.stateAnnul) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna F. El campo estado debe ser valores como:\n 1: Abierta, \n 2: Cerrada Inicial, \n 3: Cerrada Final, \n 4: Anulada.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //G. Fecha:
            const dateString = element[6] as string;
            if (dateString == null || dateString === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna G. El campo fecha es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }
            purchaseOrderDate = moment(dateString, 'DD/MM/YYYY HH:mm').toDate();
            if (!moment(dateString, 'DD/MM/YYYY HH:mm').isValid()) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna G. La fecha no es válida.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //H. Documento Proveedor:
            providerDocument = element[7] as string;
            if (providerDocument == null || providerDocument === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna H. El campo documento proveedor es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //I. Forma de Pago:
            wayToPayCode = parseFloat(element[8] as string);
            if (isNaN(wayToPayCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna I. El campo forma de pago es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }
            if (wayToPayCode != 1 && wayToPayCode != 2) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna I. El campo forma de pago debe ser valores como:\n 1: Contado, \n 2: Crédito.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //J. Documento Referencia:
            referenceDocument = element[9] as string;
            if (referenceDocument != null && referenceDocument.length > 10) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna J. El campo documento referencia supera el máximo de caracteres (10).`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //K. Dirección:
            address = element[10] as string;
            if (address == null || address == "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna K. El campo dirección es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            } else if (address.length > 100) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna K. El campo dirección supera el máximo de caracteres (100).`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //L. Observación:
            observation = element[11] as string;
            if (observation != null && observation.length > 250) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna L. El campo observación supera el máximo de caracteres (250).`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //M. Subtotal:
            subtotalValue = parseFloat(element[12] as string);
            if (isNaN(subtotalValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna M. El campo subtotal es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //N. Iva:
            ivaValue = parseFloat(element[13] as string);
            if (isNaN(ivaValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna N. El campo iva es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //O. Código Artículo
            articleCode = parseFloat(element[14] as string);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna O. El código de artículo es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //P. Cantidad:
            quantity = parseFloat(element[15] as string);
            if (isNaN(quantity)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna P. El campo cantidad es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //Q. Cantidad Ajuste:
            ajustedQuantity = parseFloat(element[16] as string);
            if (isNaN(ajustedQuantity)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna Q. El campo cantidad ajuste es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //R. Valor Unitario:
            unitValue = parseFloat(element[17] as string);
            if (isNaN(unitValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna R. El campo valor unitario es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //S. Valor Unitario Ajuste:
            ajustedUnitValue = parseFloat(element[18] as string);
            if (isNaN(ajustedUnitValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna S. El campo valor unitario ajuste es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //T. Porcentaje Descuento:
            discountRate = parseFloat(element[19] as string);
            if (isNaN(discountRate)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna T. El campo porcentaje descuento es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //U. Porcentaje Descuento Ajuste:
            ajustedDiscountRate = parseFloat(element[20] as string);
            if (isNaN(ajustedDiscountRate)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna U. El campo porcentaje descuento ajuste es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //V. Porcentaje IVA:
            ivaRate = parseFloat(element[21] as string);
            if (isNaN(ivaRate)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna V. El campo porcentaje iva es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //W. Porcentaje IVA Ajuste:
            ajustedIvaRate = parseFloat(element[22] as string);
            if (isNaN(ajustedIvaRate)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna W. El campo porcentaje iva ajuste es obligatorio.`;
              this.purchaseOrderAlerts.push(alert);
              rowHasError = true;
            }

            //X. Pedido Interno:
            internalOrderConsecutive = parseFloat(element[23] as string);

            if (!rowHasError) {
              row = new PurchaseOrderImportModel(counter, this.companyId, branchCode, consecutive, alterNumber, purchaseOrderDate, enterpriseCode, providerDocument, address, wayToPayCode,
                referenceDocument, purchaseOrderState, observation, subtotalValue, ivaValue, articleCode, quantity, ajustedQuantity, unitValue, ajustedUnitValue, discountRate, ajustedDiscountRate,
                ivaRate, ajustedIvaRate, internalOrderConsecutive);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });
          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.purchaseOrderService.importPurchaseOrder(rowsImports));
              this.loadPreInvoicingModel = response;
              this.purchaseOrderAlerts = response?.alerts ?? [];
              this.errorPurchaseOrder = response?.preInvoicingStateId;

              if (this.errorPurchaseOrder === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.purchaseOrderAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
              } else {
                this.visibleTxt = false;
                this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
              }
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar las ordenes de compra.', error);
            }
            (<HTMLInputElement>document.getElementById('fileImport')).value = '';
          } else {
            this.errorPurchaseOrder = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        this.toastHandlerService.showToast('error', 'No ha seleccionado ningún archivo.');
      }
    }
  }

  async getAllLists() {
    try {
      const [companies] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),

      ]);
      this.listCompanies = companies;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  getCompany(companyId: number | null) {
    if (companyId && companyId !== 0) {
      this.companyId = companyId;
      const company = this.listCompanies.find(x => x.value === companyId);
      this.companyCode = company ? company.code : null;
    } else {
      this.companyId = 0;
      this.companyCode = null;
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por perfil.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatiria.',
      },
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formImport.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm() {
    this.formImport = this.formBuilder.group({
      companyId: [0, [Validators.required, Validators.min(1)]],
    });
  }
}
